module.exports = __webpack_public_path__ + "img/softball-stadium-pic-619.e2b6f2b2.jpg";